import { ReputationApi } from 'api-typings/users/users';
import { transformReputationDataWithRehire } from '../reputation/reputation.transformers';
import { FreelancerReputationWithRehire } from './freelancer-reputations-rehire-rates.model';

export function transformFreelancerReputationswithRehire(
  reputation: ReputationApi,
): FreelancerReputationWithRehire {
  if (!reputation.user_id) {
    throw new ReferenceError('Missing a required reputation field.');
  }

  return {
    entireHistory: transformReputationDataWithRehire(reputation.entire_history),
    id: reputation.user_id,
    role: reputation.role,
    earningsScore: reputation.earnings_score,
  };
}
